import { cva } from 'class-variance-authority';
import type { ReactNode } from 'react';
import { cn } from '../../../lib/utils';
import type { MenuSize } from './menu-size-context';

// row overrides on top of `menuItemVariants`: grows with its content and stacks the text
export const menuDescriptionItemVariants = cva('h-auto flex-col items-start gap-2 text-left', {
  variants: {
    size: {
      sm: 'py-3',
      standard: 'py-4',
    },
  },
  defaultVariants: {
    size: 'sm',
  },
});

// clipped on x only: with line height 1 the descenders sit below the box
const titleVariants = cva('w-full overflow-x-clip leading-none text-ellipsis whitespace-nowrap', {
  variants: {
    size: {
      sm: 'typo-sm-semibold',
      standard: 'typo-base-semibold',
    },
  },
});

// two lines by default; `line-clamp-1` for one, `line-clamp-none` to wrap in full
const descriptionVariants = cva('line-clamp-2 w-full text-text-secondary', {
  variants: {
    size: {
      sm: 'typo-xs',
      standard: 'typo-sm',
    },
  },
});

export type MenuDescriptionItemTextProps = {
  size: MenuSize;
  title: ReactNode;
  description?: ReactNode;
  descriptionId: string;
  classNames?: {
    title?: string;
    description?: string;
  };
  children?: ReactNode;
};

export const MenuDescriptionItemText = ({
  size,
  title,
  description,
  descriptionId,
  classNames,
  children,
}: MenuDescriptionItemTextProps) => (
  <>
    <span className={cn(titleVariants({ size }), classNames?.title)}>{title}</span>
    {description ? (
      <span
        id={descriptionId}
        className={cn(descriptionVariants({ size }), classNames?.description)}>
        {description}
      </span>
    ) : null}
    {children}
  </>
);
